import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

export default function News(props) {
  const { image, date, text, className, author, content, link, id } = props

  const renderContent = () => {
    if (!content) return
    return <p className="News-content">{content}</p>
  }

  return (
    <div className={`News-box ${className}`}>
      <div className="News-wrapper">
        <figure className="News-figure">
          <Link to={link} state={{ id: id }} className="News-link">
            <img className="News-image" src={image} alt="" />
          </Link>
        </figure>
        <div className="News-info">
          <date className="News-date">{date}</date>
          <Link to={link} state={{ id: id }} className="News-text">
            {text}
          </Link>
          {renderContent()}
          <span className="News-author">{author}</span>
        </div>
      </div>
    </div>
  )
}

News.propTypes = {
  image: PropTypes.string.isRequired,
  author: PropTypes.string,
  date: PropTypes.string,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  content: PropTypes.string,
  link: PropTypes.string,
  id: PropTypes.number,
}

News.defaultProps = {
  image: "",
  author: "",
  date: "",
  text: "",
  className: "",
  content: "",
}
